import { type ReactElement } from "react";
import { useDarkMode } from "@/context";
import { Logo, Toggle, LangToggle } from "@/components";

export const Header = (): ReactElement => {
  const { modeClass } = useDarkMode();

  return (
    <header className={`header ${modeClass}`}>
      <Logo />
      <div className="header-actions">
        <LangToggle />
        <Toggle />
      </div>
    </header>
  );
};
